import { DialogActions } from "@mui/material";

export const MuiDialogActions = DialogActions;
